import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#111111] py-12">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <a 
            href="https://styleoutlet.es" 
            target="_blank" 
            rel="noopener noreferrer"
            className="font-serif text-2xl font-bold text-white hover:text-[#C8A96A] transition-colors cursor-pointer"
          >
            Style<span className="text-[#C8A96A]">Outlet</span>
          </a>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <a 
              href="https://styleoutlet.es/10-trucco" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-sans text-sm text-white/60 hover:text-[#C8A96A] transition-colors cursor-pointer"
            >
              Trucco
            </a>
            <a 
              href="https://styleoutlet.es/18-naelle" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-sans text-sm text-white/60 hover:text-[#C8A96A] transition-colors cursor-pointer"
            >
              Naelle
            </a>
            <a 
              href="https://styleoutlet.es/28-top-ventas" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-sans text-sm text-white/60 hover:text-[#C8A96A] transition-colors cursor-pointer"
            >
              Top Ventas
            </a>
            <a 
              href="https://styleoutlet.es/44-super-ofertas" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-sans text-sm text-white/60 hover:text-[#C8A96A] transition-colors cursor-pointer"
            >
              Super Ofertas
            </a>
          </div>

          {/* Copyright */}
          <div className="flex items-center gap-2 text-white/40 text-sm font-sans">
            <span>© {currentYear} StyleOutlet</span>
            <span className="hidden sm:inline">•</span>
            <span className="hidden sm:flex items-center gap-1">
              Hecho con <Heart className="w-3 h-3 text-[#C8A96A] fill-[#C8A96A]" /> para ti
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
